import api from "./api";

export async function seriesEnroll(payload = {}) {
  const response = await api.post("/quiz/series-enroll", payload);
  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to enroll in this test series.');
  }

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
